import React, { Component } from 'react';
import { DatePicker, Table, Select } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import styled from 'styled-components';
import utils from '../../common/utils';
import moment from 'moment';
import consts from '../../consts';


const ChartWrapper = styled.div`
  padding: 16px;
  background: white;
  margin-bottom: 10px;
  &>div{
      width:100%;
      display:flex;
      justify-content:flex-end;
      margin-bottom:16px;
  }
  &>div>.ant-select {
      width: 300px;
  }
`;

Highcharts.setOptions({
    lang: {
        months: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
        ]
    }
});

const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;
const { Option } = Select;
class InOutOrderTrans extends Component {
    getColumns = (t) => {
        return [
            {
                align: "center",
                title: "Thị trường",
                dataIndex: "market",
                key: "market",
            },
            {
                align: "center",
                title: "Tổng số",
                dataIndex: "totalCount",
                key: "totalCount",
            },
            {
                align: "center",
                title: "Số lượng mua",
                dataIndex: 'total_amount_buy',
                key: 'total_amount_buy',
                render: (totalAmountBuy, item) =>
                    <div>
                        {/* {utils.formatCurrency(totalAmountBuy)} */}
                        {totalAmountBuy}
                        {" "}
                        {item.coin}
                    </div>
            },
            {
                align: "center",
                title: "Số lượng bán",
                dataIndex: 'total_amount_sell',
                key: 'total_amount_sell',
                render: (totalAmountSell, item) =>
                    <div>
                        {utils.formatCurrency(totalAmountSell)}
                        {" "}
                        {item.currency}
                    </div>
            },
            {
                align: "center",
                title: "Phí mua",
                dataIndex: "total_fee_buy",
                key: "total_fee_buy",
                render: (totalFeeBuy, item) =>
                    <div>
                        {utils.formatCurrency(totalFeeBuy)}
                        {" "}
                        {item.coin}
                    </div>
            },
            {
                align: "center",
                title: "Phí bán",
                dataIndex: "total_fee_sell",
                key: "total_fee_sell",
                render: (totalFeeSell, item) =>
                    <div>
                        {utils.formatCurrency(totalFeeSell)}
                        {" "}
                        {item.currency}
                    </div>
            },
        ]
    }

    constructor(props) {
        super(props)
        this.filter = {
            begin: moment().subtract(7, 'days').unix(),
            end: moment().unix(),
        }
        this.coinFilter = {
            coin: 'ETH',
            currency: 'USDT',
        }

    }

    componentDidMount() {
        this.props.onFetchInOutOrderTransAction(this.filter)
        this.props.onFetchInOutOrderTransChartAction({...this.filter,...this.coinFilter})
    }

    disabledDate(current) {
        return current && current > moment().endOf('day');
    }

    onChangeDate = (current) => {
        if (current) {
            this.filter = {
                ...this.filter,
                begin: current[0].startOf('day').unix(),
                end: current[1].endOf('day').unix(),
            }
        }
        else {
            this.filter = {
                ...this.filter,
                begin: '',
                end: '',
            }
        }
        this.props.onFetchInOutOrderTransAction(this.filter);
        this.props.onFetchInOutOrderTransChartAction({...this.filter,...this.coinFilter})

    }

    onMarketChange = (value) => {
        this.coinFilter = {
            coin: this.props.markets[value].coin,
            currency: this.props.markets[value].currency,
        }
        this.props.onFetchInOutOrderTransChartAction({...this.filter,...this.coinFilter})
    }

    render() {
        return (
            <div className="withdrawalHistory mr-medium ml-medium" >
                <h3>Lệnh giao dịch</h3>
                <div>
                    <RangePicker
                        disabledDate={this.disabledDate}
                        format={dateFormat}
                        onChange={this.onChangeDate}
                        locale={consts.LangDateVi}
                        defaultValue={[moment.unix(this.filter.begin), moment.unix(this.filter.end)]}
                    />
                </div>
                <div className='mt-medium'>
                    <ChartWrapper>
                        <div>
                            <Select
                                onChange={this.onMarketChange}
                                defaultValue={'ETH:USDT'}
                            >
                                {this.props.markets.map((item, index) => (
                                    <Option value={index}>
                                        {`${item.coin}:${item.currency}`}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <HighchartsReact highcharts={Highcharts} options={{
                            chart: {
                                type: 'spline'
                            },

                            title: {
                                text: this.props.name
                            },
                            xAxis: {
                                type: 'datetime',
                                labels: {
                                    format: "{value:%e/%B/%Y}",
                                },
                            },
                            yAxis: {
                            },
                            series: [
                                {
                                    name: "Tổng ",
                                    data: this.props.inOutOrderTransChart.map((item) => ([item.time_stamp * 1000, item.total_amount]))
                                },
                                {
                                    name: "Tổng số lượng",
                                    data: this.props.inOutOrderTransChart.map((item) => ([item.time_stamp * 1000, item.total_quantity]))
                                },
                                {
                                    name: "Tổng số lượng bán",
                                    data: this.props.inOutOrderTransChart.map((item) => ([item.time_stamp * 1000, item.total_buy_fee]))
                                },
                                {
                                    name: "Tổng số lượng mua",
                                    data: this.props.inOutOrderTransChart.map((item) => ([item.time_stamp * 1000, item.total_sell_fee]))
                                },
                                {
                                    name: "Tổng lệnh",
                                    data: this.props.inOutOrderTransChart.map((item) => ([item.time_stamp * 1000, item.total_count]))
                                },
                            ]
                        }} />
                    </ChartWrapper>

                    <Table dataSource={this.props.inOutOrderTrans}
                        columns={this.getColumns()}
                        bordered
                        pagination={{
                            hideOnSinglePage: true,
                        }} />;
                </div>
            </div>
        )
    }
}

export default InOutOrderTrans;
